import dayjs, { Dayjs } from "dayjs";
import { atom } from "jotai";
import { StaffGenreFilter } from "views/StaffSchedule/tools";

export const staffScheduleStartDateFilterAtom = atom<Dayjs>(
  dayjs().startOf("month"),
);
export const staffScheduleStaffGenreFilterAtom = atom<StaffGenreFilter>("ALL");
export const staffScheduleSearchFilterAtom = atom("");
